import { StyleSheet, Text, View, TextInput, TouchableOpacity, } from 'react-native'
import React from 'react'

type Props = {
    value: string,
    onValueChange: (otp: string) => void,
    handleVerifyOptp: () => void,
    hideModel: () => void,
    loading: boolean
}

export default function OtpModalView(props: Props) {
    return (
        <View style={{
            backgroundColor: "white",
            margin: 20,
            padding: 20,
            borderRadius: 12
        }}>
            <Text style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 10
            }}>
                6 digit OTP sent to your email
            </Text>

            <TextInput
                placeholder="Enter OTP"
                value={props.value}
                onChangeText={props.onValueChange}
                keyboardType="number-pad"
                maxLength={6}
                style={{
                    borderWidth: 1,
                    borderColor: "#ccc",
                    padding: 12,
                    borderRadius: 8,
                    marginBottom: 15
                }}
            />

            <TouchableOpacity
                onPress={() => props.handleVerifyOptp()}
                style={{
                    backgroundColor: "#000",
                    padding: 14,
                    borderRadius: 8,
                    alignItems: "center"
                }}
                disabled={props.loading}
            >
                <Text style={{ color: "white", fontWeight: "bold" }}>
                    {props.loading ? "Verifying..." : "Verify OTP"}
                </Text>
            </TouchableOpacity>

            <TouchableOpacity
                onPress={() => props.hideModel()}
                style={{ marginTop: 10 }}
            >
                <Text style={{ textAlign: "center", color: "red" }}>
                    Cancel
                </Text>
            </TouchableOpacity>
        </View>

    )
}

const styles = StyleSheet.create({})